<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="650px" @close="cancel">
      <div class="content">
        <img
          class="result-icon"
          src="@static/images/authentication/result.png"
          alt=""
        />
        <div class="result-text">已提交</div>
        <div class="result-tip">
          您的认证信息已提交，我们将在1-2个工作日内完成认证审核；认证中不允许修改信息，如有特殊情况需要修改，请联系您的商务经理或客服（400-8788-100）。
        </div>
        <div class="img-tip">
          <div class="img-info">
            <img
              class="wechat-img"
              @click="getWechatCode"
              title="点击刷新"
              :src="codeUrl"
            />
            <div>点击刷新二维码</div>
          </div>
          <div class="text">
            扫码二维码将账号与您的微信绑定，即可在凤栖云服公众号实时接收认证结果、认证通过后可接收平台公告以及出单通知等。
          </div>
        </div>
      </div>

      <div class="submit-box">
        <el-button
          type="warning"
          size="small"
          class="submit-btn"
          @click="cancel"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    codeUrl: String,
  },
  components: {},
  data() {
    return {
      dialogVisible: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    getWechatCode() {
      this.$emit("getWechatCode");
    },
    cancel() {
      this.dialogVisible = false;
      location.reload();
    }
  },
};
</script>

<style scoped lang="scss">
.content {
  text-align: center;
  .result-icon {
    margin-top: -20px;
  }
  .result-text {
    font-size: 24px;
    font-weight: 500;
    color: #333333;
    margin: 20px 0 30px;
  }
  .result-tip {
    font-size: 14px;
    color: #666;
    text-align: left;
    margin-bottom: 30px;
    line-height: 24px;
  }
  .img-tip {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 142px;
    padding: 0 32px;
    background-color: #f7f7f7;
    .img-info {
      div {
        width:100px;
        font-size: 12px;
        text-align: center;
      }
    }
    .wechat-img {
      display: block;
      width: 100px;
      height: 100px;
    }
    .text {
      width: 370px;
      font-size: 14px;
      color: #666;
      text-align: left;
    }
  }
}
.submit-box {
  display: flex;
  justify-content: center;
  padding-top: 30px;
  .submit-btn {
    width: 150px;
    height: 40px;
    background: #fd9201;
    opacity: 1;
    border-radius: 4px;
  }
}
/deep/ .el-dialog__body {
  padding: 30px 48px;
}
</style>
